import Vue from 'vue';
export const Guci = new Vue()



// WEBPACK FOOTER //
// ./src/AnonymousLetterManagement/components/brothersEvent.js